// Modern Netflix-inspired Dark Theme (Red/White/Black)
export const darkTheme = {
    bg: "#000000",              // Pure Black
    bgLight: "#141414",        // Netflix Dark Gray
    primary: "#E50914",         // Netflix Red
    secondary: "#B81D24",       // Darker Red
    text_primary: "#FFFFFF",    // White
    text_secondary: "#B3B3B3",  // Netflix Light Gray
    card: "#181818",           // Card Dark
    card_light: '#2F2F2F',     // Lighter Card
    button: "#E50914",         // Red Button
    button_secondary: "#FFFFFF", // White Button
    white: "#FFFFFF",
    black: "#000000",
    border: "#333333",         // Subtle Dark Border
    success: "#46D160",        // Green
    error: "#E50914",          // Red
}

// Clean Light Theme with modern colors
export const lightTheme = {
    bg: "#DAE0E6",             // Reddit's light gray background
    bgLight: "#FFFFFF",       // Pure white
    primary: "#FF4500",        // Reddit orange
    secondary: "#0079D3",      // Reddit blue
    text_primary: "#1A1A1B",   // Dark text
    text_secondary: "#7C7C7C", // Gray text
    card: "#FFFFFF",           // White cards
    card_light: "#F6F7F8",   // Very light gray
    button: "#FF4500",        // Orange buttons
    button_secondary: "#0079D3", // Blue button variant
    white: "#FFFFFF",
    black: "#000000",
    border: "#EDEFF1",        // Light borders
    success: "#46D160",       // Green
    error: "#EA0027",         // Red
}